var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import darken from "polished/lib/color/darken.js";

import commonProps, { omitCommonProps } from "./_commonProps";

var Link = React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
      props = _objectWithoutProperties(_ref, ["as"]);

  var LinkComponent = as || "a";
  return React.createElement(LinkComponent, _extends({ ref: ref }, omitCommonProps(props)));
});

var StyledLink = styled(Link).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-68ya0f-0"
})(["position:relative;", ";text-decoration:none;cursor:pointer;letter-spacing:0.2px;&:before{content:\"\";position:absolute;width:100%;height:2px;bottom:0;left:0;background-color:currentColor;visibility:hidden;transform:scaleX(0);transition:all 0.3s ease-in-out 0s;}&:hover:before{visibility:visible;transform:scaleX(1);}&:active{color:", ";}", ";"], commonProps, function (props) {
  return darken(0.2, props.theme[props.color]);
}, function (props) {
  return props.noUnderline && css(["&:hover:before{visibility:hidden;}"]);
});

StyledLink.propTypes = {
  bold: PropTypes.bool,
  color: PropTypes.string,
  noUnderline: PropTypes.bool
};

StyledLink.defaultProps = {
  bold: true,
  color: "primary",
  noUnderline: false
};

export default StyledLink;